export default "__VITE_ASSET__GJP1c0uw__"